import React, { useMemo } from 'react';
import { BadgeDesign, badgeSVG } from './badge-svg';

interface BadgeProps {
  design: BadgeDesign;
  size: number;
  label?: string;
  locked?: boolean;
  className?: string;
}

export const Badge = ({ design, size, label, locked, className }: BadgeProps) => {
  const markup = useMemo(() => badgeSVG(design, { size, label, locked }), [design, size, label, locked]);
  return (
    <span
      className={className}
      style={{ display: 'inline-flex', lineHeight: 0, opacity: locked ? 0.7 : 1 }}
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: markup }}
    />
  );
};
